/* eslint-disable import/prefer-default-export */
export const optionsCategory = (t) => [
    {
        aclCode: 'header_catalog',
        key: 'catalog',
        label: t('menu:Catalog'),
        notInAcl: true,
        children: [
            {
                aclCode: 'channel_category',
                key: 'channelcategory',
                label: t('menu:Channel_Category'),
                url: '/admin/catalog/channelcategory',
                notInAcl: true,
                // hide: true,
            },
            {
                aclCode: 'category_mapping',
                key: 'categorymapping',
                label: t('menu:Category_Mapping'),
                url: '/admin/catalog/categorymapping',
                notInAcl: true,
                // hide: true,
            },
            {
                aclCode: 'channel_metafield',
                key: 'channelmetafieldassign',
                label: t('menu:Assign_Metafields') === 'Assign_Metafields'
                    ? 'Assign Metafields'
                    : t('menu:Assign_Metafields'),
                url: '/admin/catalog/channelmetafield/assign',
                notInAcl: true,
            },
            {
                aclCode: 'channel_metafield',
                key: 'channelmetafield',
                label: t('menu:Channel_Metafields') === 'Channel_Metafields'
                    ? 'Channel Metafields'
                    : t('menu:Channel_Metafields'),
                url: '/admin/catalog/channelmetafield',
                notInAcl: true,
            },
            {
                aclCode: 'channel_attribute_mapping',
                key: 'channelattributemapping',
                label: t('menu:Channel_Attribute_Mapping'),
                url: '/admin/catalog/channelattributemapping',
                notInAcl: true,
                // hide: true,
            },
            {
                aclCode: 'channel_attribute_config',
                key: 'channelattributeconfig',
                label: t('menu:Channel_Attribute_Config'),
                url: '/admin/catalog/channelattributeconfig',
                notInAcl: true,
                // hide: true,
            },
        ],
    },
];
